exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".popover-popover-6X8RLloHmwr{display:inline-block}.popover-popover-body-4HTNf3iFmwr{max-height:100vh;overflow:auto}.popover-close-3oKIHJFUmwr{cursor:pointer}.popover-top-container-3cQXO5qKmwr{align-items:center;border-bottom:1px solid #DEDEDE;display:flex;justify-content:space-between;padding:8px}.popover-title-2MahYP4Qmwr{font-size:16px;line-height:20px;margin:0;padding-left:8px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"popover": "popover-popover-6X8RLloHmwr",
	"popover-body": "popover-popover-body-4HTNf3iFmwr",
	"popoverBody": "popover-popover-body-4HTNf3iFmwr",
	"close": "popover-close-3oKIHJFUmwr",
	"top-container": "popover-top-container-3cQXO5qKmwr",
	"topContainer": "popover-top-container-3cQXO5qKmwr",
	"title": "popover-title-2MahYP4Qmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["bold"] + ""
};